"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function getHeight(content) {
  if (content && content.current && content.current.scrollHeight) {
    return "".concat(content.current.scrollHeight, "px");
  }

  return '0px';
}

var useCollapse = function useCollapse(_ref) {
  var isOpen = _ref.isOpen,
      content = _ref.content;

  var _useState = (0, _react.useState)('0'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      height = _useState2[0],
      setHeight = _useState2[1];

  var _useState3 = (0, _react.useState)('hidden'),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      overflow = _useState4[0],
      setOverflow = _useState4[1];

  var _useState5 = (0, _react.useState)('hidden'),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      visibility = _useState6[0],
      setVisibility = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isFirstRender = _useState8[0],
      setIsFirstRender = _useState8[1];

  var setIsExpandedStyle = function setIsExpandedStyle() {
    setHeight('auto');
    setOverflow('visible');
    setVisibility('visible');
  };

  var setIsCollapsedStyle = function setIsCollapsedStyle() {
    setVisibility('hidden');
  };

  (0, _react.useEffect)(function () {
    if (isOpen) {
      setVisibility('visible');

      if (isFirstRender) {
        setHeight('auto');
        setOverflow('visible');
      } else {
        setHeight(getHeight(content));
      }
    } else if (!isFirstRender) {
      setHeight(getHeight(content)); // The magic: Set collapsed style after setting height to enable smooth transition based on height

      window.requestAnimationFrame(function () {
        // Setting these properties will start transition from measured height to 0
        setTimeout(function () {
          // Setting these properties will start transition from measured height to 0
          setHeight('0');
          setOverflow('hidden');
        });
      });
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    setIsFirstRender(false);
  }, []);
  return {
    setIsExpandedStyle: setIsExpandedStyle,
    setIsCollapsedStyle: setIsCollapsedStyle,
    style: {
      overflow: overflow,
      visibility: visibility,
      height: height
    }
  };
};

var _default = useCollapse;
exports.default = _default;
//# sourceMappingURL=useCollapse.js.map